// turn off eslint for this file
/* eslint no-console: "off" */
export function loadState(key = 'state') {
  try {
    const state = localStorage.getItem(key);
    if (state === null) {
      return undefined;
    }
    return JSON.parse(state);
  } catch (err) {
    console.info('Session storage cannot be accessed!');
    return undefined;
  }
}

export function saveState(value, key = 'state') {
  try {
    const serailaizedState = JSON.stringify(value);
    localStorage.setItem(key, serailaizedState);
    return true;
  } catch (err) {
    console.info('Saving state to session storage failed');
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js